var map = {
	"./actions/backspace.svg": 88722,
	"./actions/bookmark-add.svg": 2003,
	"./actions/bookmark-check.svg": 84446,
	"./actions/bookmark-remove.svg": 11298,
	"./actions/camera.svg": 72056,
	"./actions/close-circle.svg": 40356,
	"./actions/close-square.svg": 25485,
	"./actions/delete-key.svg": 68494,
	"./actions/headphones.svg": 17484,
	"./actions/lock.svg": 31200,
	"./actions/minus-circle.svg": 41732,
	"./actions/minus-square.svg": 26861,
	"./actions/pause.svg": 29237,
	"./actions/play-rounded-square.svg": 65793,
	"./actions/play.svg": 32639,
	"./actions/plus-circle.svg": 54086,
	"./actions/plus-square.svg": 67963,
	"./actions/printer.svg": 50387,
	"./actions/send-circle.svg": 95928,
	"./actions/share-forward.svg": 28834,
	"./actions/share-network.svg": 72467,
	"./actions/square-duplicate.svg": 25160,
	"./actions/square-plus-stack.svg": 85982,
	"./actions/trash.svg": 929,
	"./actions/unlock.svg": 381,
	"./actions/video-camera.svg": 73898,
	"./actions/video-off.svg": 29798,
	"./actions/volume-high.svg": 27816,
	"./actions/volume-low.svg": 98210,
	"./actions/volume-muted-cross.svg": 68862,
	"./actions/volume-muted-slash.svg": 28645,
	"./chats-and-reactions/chat-bubble.svg": 18653,
	"./chats-and-reactions/fire.svg": 93904,
	"./chats-and-reactions/flag.svg": 43202,
	"./chats-and-reactions/heart-off.svg": 42404,
	"./chats-and-reactions/heart.svg": 54592,
	"./chats-and-reactions/help-chat.svg": 77192,
	"./chats-and-reactions/mail.svg": 73857,
	"./chats-and-reactions/mic-off.svg": 80473,
	"./chats-and-reactions/mic.svg": 56437,
	"./chats-and-reactions/smile-happy.svg": 75269,
	"./chats-and-reactions/smile-off.svg": 96500,
	"./chats-and-reactions/sparkles.svg": 92173,
	"./chats-and-reactions/star.svg": 82500,
	"./chats-and-reactions/thumbs-down.svg": 11676,
	"./chats-and-reactions/thumbs-up.svg": 17207,
	"./files/abstract-mark.svg": 12615,
	"./files/archive-bin.svg": 52629,
	"./files/book-open.svg": 65927,
	"./files/document-check.svg": 38281,
	"./files/document-edit.svg": 67191,
	"./files/document-plus.svg": 14291,
	"./files/document-remove.svg": 92611,
	"./files/document-tray.svg": 96691,
	"./files/document.svg": 18506,
	"./files/file-plus.svg": 31048,
	"./files/filmstrip.svg": 76003,
	"./files/folder-add.svg": 35727,
	"./files/folder-check.svg": 26434,
	"./files/folder-remove.svg": 17406,
	"./files/folder.svg": 52221,
	"./files/folders.svg": 852,
	"./files/image.svg": 72656,
	"./files/letter.svg": 98493,
	"./files/music-notes.svg": 17594,
	"./files/page.svg": 91744,
	"./files/pdf.svg": 93529,
	"./files/pushpin.svg": 42786,
	"./files/sticker-note.svg": 76435,
	"./files/video-playlist.svg": 8589,
	"./interface/alarm-clock.svg": 25521,
	"./interface/apps.svg": 29165,
	"./interface/bookmark.svg": 85053,
	"./interface/bookmarks.svg": 89684,
	"./interface/calendar.svg": 15707,
	"./interface/clock.svg": 54357,
	"./interface/cloud.svg": 3192,
	"./interface/cursor-broadcast.svg": 42829,
	"./interface/dashboard-media.svg": 64276,
	"./interface/data-layers.svg": 20023,
	"./interface/database.svg": 72338,
	"./interface/devices-monitor-phone.svg": 40060,
	"./interface/gamepad.svg": 38194,
	"./interface/globe.svg": 50296,
	"./interface/grid-apps.svg": 4030,
	"./interface/grid-minus.svg": 27942,
	"./interface/grid-plus.svg": 37870,
	"./interface/grid-remove.svg": 6214,
	"./interface/key-card.svg": 80317,
	"./interface/key.svg": 85270,
	"./interface/keyboard.svg": 30902,
	"./interface/laptop.svg": 65981,
	"./interface/layout.svg": 67747,
	"./interface/mask-theater.svg": 81021,
	"./interface/monitor.svg": 25729,
	"./interface/moon.svg": 66614,
	"./interface/phone-blocked.svg": 59604,
	"./interface/phone-circle.svg": 82440,
	"./interface/phone-message.svg": 33553,
	"./interface/phone-ringing.svg": 88670,
	"./interface/phone.svg": 25579,
	"./interface/puzzle-piece.svg": 16500,
	"./interface/setting.svg": 31203,
	"./interface/sliders.svg": 3569,
	"./interface/smartphone-home.svg": 51364,
	"./interface/smartphone-notch.svg": 40801,
	"./interface/speedometer.svg": 55400,
	"./interface/stopwatch.svg": 32358,
	"./interface/sun.svg": 43681,
	"./interface/toggle-off.svg": 24249,
	"./interface/toggle-on.svg": 19109,
	"./interface/tv-antenna.svg": 72429,
	"./navigation-and-transport/airplane.svg": 97300,
	"./navigation-and-transport/beach-lounger.svg": 35920,
	"./navigation-and-transport/bed.svg": 46823,
	"./navigation-and-transport/bus-front.svg": 97106,
	"./navigation-and-transport/car-front.svg": 54802,
	"./navigation-and-transport/car-police-taxi.svg": 93652,
	"./navigation-and-transport/chevron-down-circle.svg": 82325,
	"./navigation-and-transport/chevron-left-circle.svg": 79556,
	"./navigation-and-transport/chevron-right-circle.svg": 26511,
	"./navigation-and-transport/chevron-up-circle.svg": 8952,
	"./navigation-and-transport/compass.svg": 22230,
	"./navigation-and-transport/home.svg": 85523,
	"./navigation-and-transport/map-folded.svg": 38479,
	"./navigation-and-transport/map-pin.svg": 38442,
	"./navigation-and-transport/navigation-arrow.svg": 50936,
	"./navigation-and-transport/navigation-off.svg": 66944,
	"./navigation-and-transport/train-front.svg": 3902,
	"./navigation-and-transport/umbrella.svg": 6126,
	"./other/yandex-alice.svg": 87512,
	"./other/yandex-y-circle.svg": 96646,
	"./other/yandex-ya-circle.svg": 231,
	"./payments/basket.svg": 57633,
	"./payments/cart.svg": 86381,
	"./payments/credit-card.svg": 68327,
	"./payments/discount-coupon.svg": 29453,
	"./payments/gift-card.svg": 5700,
	"./payments/gift.svg": 20269,
	"./payments/price-tag.svg": 34145,
	"./payments/ruble-circle.svg": 4648,
	"./payments/shopping-bag.svg": 77826,
	"./payments/ticket.svg": 93231,
	"./payments/wallet.svg": 21116,
	"./statuses-and-notifications/alert-circle.svg": 74336,
	"./statuses-and-notifications/bell-off.svg": 91980,
	"./statuses-and-notifications/bell-unread.svg": 93604,
	"./statuses-and-notifications/bell.svg": 10664,
	"./statuses-and-notifications/check-circle.svg": 28018,
	"./statuses-and-notifications/check-done-simple.svg": 11713,
	"./statuses-and-notifications/check-square.svg": 2903,
	"./statuses-and-notifications/cloud-off.svg": 96666,
	"./statuses-and-notifications/eye-off.svg": 32038,
	"./statuses-and-notifications/eye.svg": 17990,
	"./statuses-and-notifications/info-circle.svg": 41036,
	"./statuses-and-notifications/lightning-off.svg": 38407,
	"./statuses-and-notifications/lightning.svg": 10991,
	"./statuses-and-notifications/megaphone.svg": 22603,
	"./statuses-and-notifications/notification-dot.svg": 83628,
	"./statuses-and-notifications/question-circle.svg": 65676,
	"./statuses-and-notifications/shield-off.svg": 28004,
	"./statuses-and-notifications/shield.svg": 29440,
	"./statuses-and-notifications/siren.svg": 52954,
	"./statuses-and-notifications/verified-badge.svg": 95537,
	"./statuses-and-notifications/warning-triangle.svg": 44930,
	"./statuses-and-notifications/yes_icon.svg": 4488,
	"./user/person.svg": 22060,
	"./user/user-check.svg": 44593,
	"./user/user-circle.svg": 19215,
	"./user/user-id-panel.svg": 55329,
	"./user/user-minus.svg": 71593,
	"./user/user-plus.svg": 32795,
	"./user/user-remove.svg": 41307,
	"./user/users-group.svg": 49395
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 30397;